import * as yup from 'yup';

export const settingsPageScheme = yup.object({
  name: yup.string().required('Name is required'),
  gender: yup.string().required('Gender is required'),
  country_id: yup.string().required('Country is required'),
  birthdate: yup.string().required('Date of Birth is required').nullable(),
});

export const deleteAccountSchema = yup.object({
  reason: yup.string().required('Reason is required'),
  password: yup
    .string()
    .required('Password is required')
    .min(8, 'Password is too short - should be 8 chars minimum.'),
});
